var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.birthdayList),function(birthday){return _c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('p',[_vm._v(" "+_vm._s(birthday.content))])]),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"2"}},[_c('p',[_vm._v("2018-01-01")])])],1)}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347eb6a3","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Homepage/components/Notification/components/Message.vue
// module id = null
// module chunks = 